import styled from 'styled-components';
import { colors } from 'spw-theme';
import { AlignEndColumn } from 'spw-shared/globalComponents/grid';

export const BulkEditButton = styled(AlignEndColumn)<{
  $disableHoverState?: boolean;
}>`
  width: fit-content;
  margin-left: auto;
  padding: 4px;
  border-radius: 4px;
  transform: translateY(4px);
  margin-top: 19px;

  ${({ $disableHoverState }) =>
    !$disableHoverState
      ? `
  cursor: pointer;
  &.selected,
  :hover {
    background-color: ${colors.brightGray};
  }
  `
      : ''}
  .label {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: ${colors.fontColor};
  }
`;

export const AvgCardPopoverContent = styled.div`
  width: 370px;
  box-sizing: border-box;

  .drag-handle {
    cursor: move;
  }

  .header {
    padding: 24px 24px 0;
  }

  .title {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  .space-type-name {
    color: ${colors.darkGray};
    margin-top: 6px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }

  .content {
    padding: 0 24px;
  }

  .warning {
    margin-top: 21px;
    color: ${colors.red};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  .description {
    margin-top: 8px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .description > p {
    margin: 0;

    &:not(:first-child) {
      margin-top: 24px;
    }
  }

  .MuiTextField-root {
    width: 92px;
    margin-top: 24px;

    .MuiInputBase-input {
      height: 40px;
      box-sizing: border-box;
    }
  }

  .actions {
    padding: 32px 24px 24px;
    margin-top: 0;

    button {
      width: 88px;
    }

    > :not(:first-child) {
      margin-left: 16px;
    }
  }
`;
